import {
  type PriceFreezeError,
  PriceFreezeErrorEnum,
} from "@b2bportal/price-freeze-api";
import type { ErrorContentProps } from "../ErrorModal";

export const getAirPriceFreezeError = (
  pfError: PriceFreezeError,
  errorModalProps: ErrorContentProps,
  noAvailabilityProps: ErrorContentProps
) => {
  switch (pfError.PriceFreezeError) {
    case PriceFreezeErrorEnum.NotEnoughSeats:
      return noAvailabilityProps;
    case PriceFreezeErrorEnum.OfferNotFound:
      return errorModalProps;
    case PriceFreezeErrorEnum.PriceFreezeErrorCode:
      return errorModalProps;
    case PriceFreezeErrorEnum.ProductNotFound:
      return errorModalProps;
    default:
      return errorModalProps;
  }
};
